export class FieldToSearch {

  name: string;

  boost: number = 1.0;

  constructor(attr: {name: string, boost?: number}) {
    this.name = attr.name;
    if (attr.boost){
      this.boost = attr.boost;
    }
  }
}
